import * as React from 'react';
import { InjectionContext } from './InjectionContext';

export function useInjected<T extends any[]>(...defaults: T): T {
    if (process.env._STORYBOOK_) {
        // This conditional always evaluates false in production,
        // but always evalueates true in storybook, so it won't have
        // issues with conditional hook execution.
        //
        // Moreover, after compilation this evaluates to
        // `if(undefined)`, so we can rely  on webpack's dead code
        // elimination to remove this branch from the bundle entirely
        //
        // tslint:disable-next-line:react-hooks-nesting
        let contextValue = React.useContext(InjectionContext);
        return defaults.map(defaultValue => {
            if (contextValue.has(defaultValue)) {
                return contextValue.get(defaultValue);
            }
            return defaultValue;
        }) as T;
    }
    return defaults;
}
